module.exports = __webpack_public_path__ + "static/media/circle_black.b61d1bee.svg";